import { render, staticRenderFns } from "./gender.vue?vue&type=template&id=ef87f25e"
import script from "./gender.vue?vue&type=script&lang=js"
export * from "./gender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports